import ApiService from "@/services/api.service"

export const BinotelService = {
  initiateCall(phone) {
    return ApiService.post(`binotel/call/initiate`, { phone })
  },
  getCallRecording(id) {
    return ApiService.post(`binotel/call/recording`, { id })
  },
  getUISCallRecording(id) {
    return ApiService.post(`uis/call/recording`, { id })
  },
  getUISEmployees() {
    return ApiService.get(`uis/employees`)
  },
  generateTildaKey() {
    return ApiService.post(`tilda/key/generate`)
  }
}
